// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2As6i","colMin":"styles_colMin__3AXFH","colCheckbox":"styles_colCheckbox__6C6KX"};